import { UFOExperience, ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';

export const entitlementFieldGicMountExperience: UFOExperience = new UFOExperience(
	'jsm-cs-entitlement-custom-field-gic-mount',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);

export const entitlementFieldDataFetchExperience: UFOExperience = new UFOExperience(
	'jsm-cs-entitlement-custom-field-data-fetch',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);

export const entitlementFieldIssueViewMountExperience: UFOExperience = new UFOExperience(
	'jsm-cs-entitlement-custom-field-issue-view-mount',
	{
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
	},
);

export const editEntitlementFieldIssueViewExperience: UFOExperience = new UFOExperience(
	'jsm-cs-entitlement-custom-field-issue-view-edit',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);
